import { Injectable } from '@angular/core';

import { Decimal } from 'decimal.js';

import { PickOddsState } from '../../../../../core/picks/pick-models';
import { ISlip } from '../../../../bet-generation/models';
import { isBetStationFreebetToken } from '../../../../reward-tokens/services/betstation-reward-tokens.utils';
import { isFreebetToken } from '../../../../reward-tokens/services/reward-tokens.utils';
import { getSlipTotalStakeAndBetCount } from '../../../../summary/services/betslip-summary-helpers';
import { UnderMinimumWinningsPreCheckError } from '../../../errors/pre-check/under-minimum-winnings-pre-check-error';

/**
 * Under minimum winnings validator.
 * It validates bet
 */
@Injectable()
export class UnderMinimumWinningsValidator {
    *validate(slip: ISlip, possibleWinningsNet: Decimal | null): Iterable<UnderMinimumWinningsPreCheckError> {
        const { totalStake, betCount } = getSlipTotalStakeAndBetCount(slip);

        if (
            slip.stake == null ||
            possibleWinningsNet == null ||
            isFreebetToken(slip.rewardToken) ||
            isBetStationFreebetToken(slip.rewardToken) ||
            betCount === 0
        ) {
            return;
        }

        const hasLockedOrClosedPicks = Object.values(slip.slipPicks).some((slipPick) => slipPick.pick.oddsState !== PickOddsState.Open);

        if (possibleWinningsNet.greaterThan(totalStake!) || hasLockedOrClosedPicks) {
            return;
        }

        const error = new UnderMinimumWinningsPreCheckError();

        yield error;
    }
}
